import { Experience, EXPERIENCES_QUERY_KEY } from './useExperiences';
import { createCrudHooks } from '../utils/createCrudHooks';

const { useCreate, useUpdate, useDelete } = createCrudHooks<Experience>({
  endpoint: '/api/experiences',
  queryKey: EXPERIENCES_QUERY_KEY,
  getId: e => e.experienceid,
});

export const useCreateExperience = useCreate;
export const useUpdateExperience = useUpdate;
export const useDeleteExperience = useDelete;
